import { createApi } from '@reduxjs/toolkit/query/react';
import { createIbkDomainBaseQuery } from '../api/createIbkBaseQuery';
export const customIbkBaseQuery = createIbkDomainBaseQuery();
export const ibkApi = createApi({
    reducerPath: 'ibkApi',
    baseQuery: customIbkBaseQuery,
    tagTypes: [
        'EmissorOrders',
        'Emissor',
        'FiscalService',
        'Certificate',
        'Regua',
        'Series',
        'Clientes',
        'Services',
        'NotasFiscais',
        'Vendas',
        'ContasAReceber',
        'Categories',
        'CostCenters',
        'Brand',
        'FinancialSettings',
    ],
    endpoints: () => ({}),
});
